import React from "react";
import ReactDOM from "react-dom/client";
import "./styles/iio-tokens.css";
import "./styles/iio-components.css";
import App from "./App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);
